import './no-payments.scss';

import ComingSoon from '@basqet-dashboard/common/assets/icons/soon.svg';
import { Button } from '@basqet-dashboard/common/components';
import PropTypes from 'prop-types';
import React from 'react';

function NoPayments({ openModal, canManagePaymentLink }) {
  return (
    <div className="no_payments">
      <div className="no_payments__coming_soon">
        <img src={ComingSoon} alt="Coming soon" />
      </div>
      {canManagePaymentLink ? (
        <>
          <p className="no_payments__message">
            Payment links can be shared with people to receive payment all around the world. <br />
            Creating one takes a few steps
          </p>

          <Button onClick={openModal}>Create payment link</Button>
        </>
      ) : (
        <p className="no_payments__message">Payment links created would appear here</p>
      )}
    </div>
  );
}

NoPayments.propTypes = {
  openModal: PropTypes.func,
  canManagePaymentLink: PropTypes.bool
};

export { NoPayments };
